class MobileSearch extends window.HTMLElement {
  constructor() {
    super();
    this.lupa = document.getElementById("lupita");
    this.banderaLupa = true;
    this.toggleLupa = this.toggleLupa.bind(this);
  }
  connectedCallback() {
    if (this.lupa) {
      this.lupa.addEventListener("click", this.toggleLupa);
    }
  }
  // Function to handle the toggle logic
  toggleLupa() {
    const searchButton = document.getElementById("cm_SearchBoxDialogButton");
    if (!searchButton) return;
    if (this.banderaLupa) {
      searchButton.classList.add("hiddeSearch");
      this.toggleIcons();
      this.banderaLupa = false;
    } else {
      searchButton.classList.remove("hiddeSearch");
      this.toggleIcons();
      this.banderaLupa = true;
    }
  }
  toggleIcons() {
    const iconSearch = this.lupa.querySelector("img.icon-search");
    const iconClose = this.lupa.querySelector("svg.icon-close");
    if (this.banderaLupa) {
      iconSearch.classList.add("hidden");
      iconSearch.classList.remove("inline-block");
      iconClose.classList.remove("hidden");
    } else {
      iconSearch.classList.remove("hidden");
      iconSearch.classList.add("inline-block");
      iconClose.classList.add("hidden");
    }
  }
}
window.customElements.define("mobile-search", MobileSearch);
